export const headerNavigation = {
  MAIN: 'navigation.mainHeader',
  TOP: 'navigation.topHeader',
  MOBILE: 'navigation.mobileHeader',
  ICON_MOBILE: 'navigation.iconMobileHeader',
  LOGO: 'navigation.logoHeader'
}
